/** The different layouts the editor should support */
export const layouts = {
  spinner: 'spinner',
  default: 'default',
  wide: 'wide',
  small: 'small',
};

/** Elements that can be a part of the editor */
export const identifiers = {
  description: 'description',
  summary: 'summary',
  api: 'api',
  implementation: 'implementation',
  solution: 'solution',
  discussion: 'discussion',
  apiSettings: 'apiSettings',
  graphicsSettings: 'graphicsSettings',
  settings: 'settings',
  preview: 'preview',
  console: 'console',
  score: 'score',
  canvas: 'canvas', // Has no tab label since it is managed separately
  result: 'result', // used for result column with canvas and console
  course: 'course', // Used for exercises when taken as part of a course
};

export const buttonIds = {
  runButton: 'freecodeRunCode',
  selectLanguage: 'freecodeSelectLanguage',
  submitButton: 'freecodeSubmitCode',
  helpButton: 'freecodeHelpButton',
};

/** Icons and labels to use for different tabs */
export const tabLabels = {
  [identifiers.description]: {
    icon: 'fa fa-info-circle',
    label: 'Description',
    tabId: 'freecodeDescriptionTab',
  },
  [identifiers.summary]: {
    icon: 'fa fa-info-circle',
    label: 'Summary',
    tabId: 'freecodeSummaryTab',
  },
  [identifiers.api]: {
    icon: 'fa fa-book',
    label: 'API',
    tabId: 'freecodeAPITab',
  },
  [identifiers.implementation]: {
    icon: 'fa fa-code',
    label: 'Implementation',
  },
  [identifiers.solution]: {
    icon: 'fa fa-code',
    label: 'Solution',
  },
  [identifiers.discussion]: {
    icon: 'fa fa-comments-o',
    label: 'Discussion',
  },
  [identifiers.apiSettings]: {
    icon: 'fa fa-book',
    label: 'API',
  },
  [identifiers.graphicsSettings]: {
    icon: 'fa fa-picture-o',
    label: 'Graphics',
  },
  [identifiers.settings]: {
    icon: 'fa fa-cog',
    label: 'Settings',
  },
  [identifiers.preview]: {
    icon: 'fa fa-file-code-o',
    label: 'Preview',
  },
  [identifiers.console]: {
    icon: 'fa fa-terminal',
    label: 'Console',
    tabId: 'freecodeConsoleTab',
  },
  [identifiers.score]: {
    icon: 'fa fa-star',
    label: 'Score',
    tabId: 'freecodeScoreTab',
  },
  [identifiers.result]: {
    icon: 'fa fa-terminal',
    label: 'Result',
  },
  [identifiers.course]: {
    icon: 'fa fa-bars fa-lg',
    label: 'Course',
  },
};
